import { render, staticRenderFns } from "./TemporaryStorageManage.vue?vue&type=template&id=c894192e&scoped=true&"
import script from "./TemporaryStorageManage.vue?vue&type=script&lang=js&"
export * from "./TemporaryStorageManage.vue?vue&type=script&lang=js&"
import style0 from "./TemporaryStorageManage.vue?vue&type=style&index=0&id=c894192e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c894192e",
  null
  
)

export default component.exports